module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folders-list",
    class: {
      inner: _vm.isInnerList
    }
  }, [(!_vm.isInnerList) ? _c('div', {
    staticClass: "individual-folder"
  }, [_c('icon', {
    staticClass: "text-primary",
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "name": "folder-o"
    }
  }), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isSelectedFolder(_vm.topLevel), disabled: _vm.isCurrentFolder(_vm.topLevel)
    },
    on: {
      "click": function($event) {
        _vm.setSelectedFolder(_vm.topLevel)
      }
    }
  }, [_vm._v("\n        (Top Level)\n      ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.folders), function(folder) {
    return _c('div', [_c('div', {
      staticClass: "individual-folder"
    }, [_c('icon', {
      staticClass: "text-primary",
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": "folder-o"
      }
    }), _vm._v(" "), _c('a', {
      class: {
        active: _vm.isSelectedFolder(folder), disabled: _vm.isCurrentFolder(folder)
      },
      on: {
        "click": function($event) {
          _vm.setSelectedFolder(folder)
        }
      }
    }, [_vm._v("\n        " + _vm._s(folder.name) + "\n      ")]), _vm._v(" "), (folder.has_descendant_folders && !_vm.isCurrentFolder(folder)) ? _c('span', {
      staticClass: "expand-button",
      on: {
        "click": function($event) {
          _vm.toggle(folder)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": folder.open ? 'minus-square-o' : 'plus-square-o'
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), (folder.descendants) ? _c('folders-list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (folder.open),
        expression: "folder.open"
      }],
      attrs: {
        "currentFolder": _vm.currentFolder,
        "folders": folder.descendants,
        "isInnerList": "true"
      }
    }) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6334fa7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoldersList.vue
// module id = 1017
// module chunks = 1